import React from 'react';

import { IRoom } from '../../../../../Models/IRoom';
import { qSVG } from '../../../../../Utils/qSVG';
import { Wall } from '../../../../../Utils/Types';
import { CoteUtils } from '../../../../Widgets/Cotes';
import { useLaizeCalcDialog } from '../../LaizeCalcDialogProvider';

export const MapUIRoomsFlooringDirection = () => {
    const { validCurrentWallStarts, state } = useLaizeCalcDialog();
    const { rooms = [] } = state;
    return (
        <g id="mapRoomsFlooringDirection">
            {rooms.map((room) => {
                const wall = room.flooringWallStart;
                return !wall ? null : (
                    <MapUIRoomFlooringDirection
                        key={`roomFlooringDirection-${room.roomId}`}
                        room={room}
                        wall={wall}
                        invalid={!validCurrentWallStarts.find((x) => x.roomId === room.roomId)?.isValid}
                    />
                );
            })}
        </g>
    );
};

type MapUIRoomFlooringDirectionProps = { room: IRoom; wall: Wall; invalid?: boolean };
export const MapUIRoomFlooringDirection = ({ room, wall, invalid }: MapUIRoomFlooringDirectionProps) => {
    const p1 = wall.start;
    const p2 = wall.end;
    const wallCenter = qSVG.middle(p1.x, p1.y, p2.x, p2.y);

    const measure = qSVG.measure(p1, p2);
    const angle = wall.angleRad * (180 / Math.PI);
    const newAngle = CoteUtils.calculateShift('inside', angle).angle;
    const strokeWidth = 8;
    const iconMargin = strokeWidth + 6;

    return (
        <g id={`roomWallFlooringDirection-${room.roomId}-${wall.sideName}`}>
            <line
                transform={`rotate(${newAngle} ${wallCenter.x},${wallCenter.y}) translate(${wallCenter.x},${
                    wallCenter.y - strokeWidth / 2
                })`}
                stroke={invalid ? '#EB5757' : '#E5A033'}
                strokeWidth={strokeWidth}
                x1={-measure / 2}
                x2={measure / 2}
            />
            <g
                transform={`rotate(${newAngle - 90} ${wallCenter.x},${wallCenter.y}) translate(${
                    wallCenter.x + iconMargin
                },${wallCenter.y - strokeWidth / 2})`}>
                <rect width={20} height={20} fill="transparent" x={-2} y={-2} />
                <Icon />
            </g>
        </g>
    );
};

const Icon = (props: React.SVGAttributes<unknown>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#ad)">
            <path
                d="m8.325 15.869 2.78-2.78a.46.46 0 0 0 0-.637l-.243-.243a.465.465 0 0 0-.649 0l-1.587 1.576V2.208l1.595 1.584a.46.46 0 0 0 .643 0l.245-.242a.463.463 0 0 0 .002-.638L8.33.132A.44.44 0 0 0 8.008 0a.45.45 0 0 0-.327.131l-2.78 2.78a.463.463 0 0 0 0 .638l.243.242a.435.435 0 0 0 .624 0l1.608-1.622v11.668L5.76 12.208a.44.44 0 0 0-.627 0l-.24.242a.45.45 0 0 0-.131.32c0 .12.047.233.132.318l2.78 2.78a.45.45 0 0 0 .323.132.45.45 0 0 0 .328-.131"
                fill="#E5A000"
            />
        </g>
        <defs>
            <clipPath id="ad">
                <path fill="#fff" d="M16 0v16H0V0z" />
            </clipPath>
        </defs>
    </svg>
);
